const PageUsers = () => import("./PageUsers.vue");

const routes = {
  navigation: [
    {
      path: "/users",
      name: "UsersOrganization",
      component: PageUsers,
    },
  ],
  organization: [
    {
      path: "users",
      name: "Users",
      component: PageUsers,
    },
  ],
};

export default routes;
